import { useLayoutEffect } from "react"
import { useSideNavigationStore } from "stores/side-navigation"
import useMediaQuery from "hooks/useMediaQuery"

/**
 * Collapsed/expanded state of the side navigation, shared by every layout.
 *
 * `compact` is the rendered state: the icon rail only exists on md+ screens.
 * Below that the sidebar is a drawer and always renders at full width,
 * whatever the persisted preference says.
 */
export const useSideNavCollapse = () => {
  const { collapsed, toggleCollapsed, setCollapsed } = useSideNavigationStore()
  const isDesktop = useMediaQuery("(min-width: 768px)")

  // Publishes the width to the layout via `--sidenav-w` (index.css). Layout
  // effect so a reload in the collapsed state paints at 64px straight away
  // instead of animating from 256px.
  useLayoutEffect(() => {
    const root = document.documentElement
    if (collapsed) root.setAttribute("data-sidenav", "collapsed")
    else root.removeAttribute("data-sidenav")
    return () => root.removeAttribute("data-sidenav")
  }, [collapsed])

  return {
    collapsed,
    compact: collapsed && isDesktop,
    toggleCollapsed,
    setCollapsed,
  }
}
